export const types = Object.freeze({
  CLEAR_REDUX_STATE: '@redux/CLEAR_REDUX_STATE'
})

export function clearRedux() {
  return { type: types.CLEAR_REDUX_STATE, payload: undefined }
}
